import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
      setIsOpen(false);
    }
  };
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b border-gray-100" role="navigation" aria-label="Navegación principal" data-id="element-128">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
        <div className="flex items-center justify-between h-16" data-id="element-130">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-131">
            <span className="font-heading text-xl font-bold text-navy-deep" data-id="element-132">
              ✝️ MegaPackCatequesis
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-133">
            <button onClick={() => scrollTo('incluye')} className="text-navy-deep hover:text-gold font-medium transition-colors duration-200" data-id="element-134">
              Qué Incluye
            </button>
            <button onClick={() => scrollTo('beneficios')} className="text-navy-deep hover:text-gold font-medium transition-colors duration-200" data-id="element-135">
              Beneficios
            </button>
            <button onClick={() => scrollTo('testimonios')} className="text-navy-deep hover:text-gold font-medium transition-colors duration-200" data-id="element-136">
              Testimonios
            </button>
            <button onClick={() => scrollTo('precios')} className="bg-gold text-navy-deep font-bold px-5 py-2 rounded-full hover:bg-gold-dark transition-colors duration-200 uppercase tracking-wide text-sm" data-id="element-137">
              COMPRAR
            </button>
          </div>

          {/* Mobile menu button */}
          <button className="md:hidden p-2 rounded-md text-navy-deep" onClick={() => setIsOpen(!isOpen)} aria-label="Abrir menú" aria-expanded={isOpen} data-id="element-138">
            {isOpen ? <XIcon className="h-6 w-6" data-id="element-139" /> : <MenuIcon className="h-6 w-6" data-id="element-140" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 space-y-3" data-id="element-141">
          <button onClick={() => scrollTo('incluye')} className="block w-full text-left text-navy-deep hover:text-gold font-medium py-2" data-id="element-142">
            Qué Incluye
          </button>
          <button onClick={() => scrollTo('beneficios')} className="block w-full text-left text-navy-deep hover:text-gold font-medium py-2" data-id="element-143">
            Beneficios
          </button>
          <button onClick={() => scrollTo('testimonios')} className="block w-full text-left text-navy-deep hover:text-gold font-medium py-2" data-id="element-144">
            Testimonios
          </button>
          <button onClick={() => scrollTo('precios')} className="block w-full bg-gold text-navy-deep font-bold px-5 py-3 rounded-full uppercase tracking-wide text-sm text-center" data-id="element-145">
            COMPRAR
          </button>
        </div>}
    </nav>;
}